import React from 'react';
import {Box, Typography, Button} from '@mui/material';
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';
import {useNavigate} from 'react-router-dom';

const MobileRestriction = () => {
    const navigate = useNavigate();

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100vh',
                padding: 4,
                textAlign: 'center',
                backgroundColor: '#f5f5f5'
            }}
        >
            <PhoneIphoneIcon sx={{ fontSize: 80, color: '#666', mb: 3 }} />
            <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold', color: '#333' }}>
                Mobile View Not Available
            </Typography>
            <Typography variant="body1" sx={{ mb: 3, color: '#666', maxWidth: '400px' }}>
                This page is optimized for desktop use. Please switch to desktop mode or use the Channels page for mobile access.
            </Typography>
            <Button
                variant="contained"
                color="primary"
                size="large"
                onClick={() => navigate('/channels')}
                sx={{ mt: 2 }}
            >
                Go to Channels
            </Button>
        </Box>
    );
};

export default MobileRestriction;

